import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { FeatureFlags, FeatureFlagsService } from '../../system-services';
import { TranslationService } from '../../translations';

@Component({
    selector: 'pi-user-grid',
    template: `
        <input
            type="text"
            class="user-management-search-filter"
            [(ngModel)]="searchText"
            placeholder="{{ TR.key('userManagement.search.placeHolder') }}"
            (ngModelChange)="onFilterBoxChanged()"
        />
        @if (enableHideNoAccessToggle() && showToggleCheckbox) {
            <tapestry-checkbox
                label="{{
                    TR.key('userManagement.toggleHideNoAccessUsers-description')
                }}"
                class="user-management-toggle-hideNoAccessUsers"
                [checked]="true"
                (checkChanged)="toggleNoAccessUsers($event)"
                (toggleCheckBox)="toggleNoAccessUsers($event)"
            >
            </tapestry-checkbox>
        }
        <tapestry-grid
            #userGrid
            class="ag-theme-tapestry-grid ag-grid-wrapper"
            [rowData]="rowData"
            [columnDefs]="columnDefinition"
            [frameworkComponents]="frameworkComponents"
            [postSortRows]="postSortRows"
            (gridReady)="onGridReady($event)"
        >
        </tapestry-grid>
    `,
    styleUrls: ['./user-grid.component.less'],
    standalone: false
})
export class UserGridComponent {
    @ViewChild('userGrid') grid!: AgGridAngular;

    @Input() columnDefinition: ColDef;
    @Input() rowData: [];
    @Input() frameworkComponents: any;
    @Input() showToggleCheckbox: boolean;
    @Output() toggleCheckBox? = new EventEmitter<boolean>();

    searchText: any;
    private gridApi!: GridApi;

    constructor(
        public TR: TranslationService,
        private featureFlags: FeatureFlagsService
    ) {}

    @Input() postSortRows = () => {};

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
    }

    async toggleNoAccessUsers(e) {
        this.toggleCheckBox.emit(e.checked);
        this.gridApi.setGridOption('loading', true);
    }

    onFilterBoxChanged() {
        this.gridApi.setGridOption('quickFilterText', this.searchText);
    }

    enableHideNoAccessToggle(): boolean {
        return this.featureFlags.getByFlag(
            FeatureFlags.enableHideNoAccessToggle
        );
    }
}
